import React from "react";
import BrokerInviteForm from "forms/BrokerInviteForm";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import { confirm, Translate } from "utils";

const { t } = new Translate("BrokerInviteModal");

const BrokerInviteModal = ({ dirty, isAssetDetailPage, onClose }) => {
  const confirmClose = () => (dirty ? confirm(() => onClose(), t("confirm.cancel")) : onClose());

  return (
    <Modal onClose={confirmClose} isOpen>
      <ModalHeader onClose={confirmClose}>{t("title")}</ModalHeader>
      <ModalBody isInfo>{t("description")}</ModalBody>
      <ModalBody>
        <BrokerInviteForm isAssetDetailPage={isAssetDetailPage} />
      </ModalBody>
    </Modal>
  );
};

BrokerInviteModal.propTypes = {
  isAssetDetailPage: PropTypes.bool,
  dirty: PropTypes.bool,
  onClose: PropTypes.func,
};

export default BrokerInviteModal;
